module.exports = __webpack_public_path__ + "static/WeChat-bf2c0872633974c575b49205740965f3.png";